import { render, staticRenderFns } from "./serverError.vue?vue&type=template&id=1f665e7a&scoped=true&"
import script from "./serverError.vue?vue&type=script&lang=js&"
export * from "./serverError.vue?vue&type=script&lang=js&"
import style0 from "./serverError.vue?vue&type=style&index=0&id=1f665e7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f665e7a",
  null
  
)

export default component.exports